<template>
  <!-- ok保提现验证 -->
  <div>
    <Modal v-model="visible" class="phone-valid-box" class-name="vertical-center-modal" width="500">
      <div slot="header" style="text-align: center">
        <h1 class="phone-valid-title">安全验证</h1>
        <p class="phone-valid-tip">为保障账户安全,请进行身份验证</p>
      </div>
      <div class="phone-code-container">
        <div class="phone-number">手机号：{{ mask(mobile) }}</div>
        <div class="phone-code-box">
          <img src="@/assets/images/icon/org/safe.png" alt />
          <input type="text" v-model="formData.code" placeholder="请输入短信验证码" />
          <span @click="getCodeAjax(mobile)" v-if="codeIndex == 60" class="active">获取验证码</span>
          <span @click="getCodeAjax(mobile)" v-else>{{ codeIndex }}S</span>
        </div>
      </div>
      <div slot="footer">
        <Button size="large" @click="visible = false">取消</Button>
        <Button type="primary" size="large" @click="ok" :disabled="!formData.code || formData.code.length == 0" :loading="pageLoading">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { common, codeTools } from '@/api/mixins';
export default {
  props: {
    type: null
  },
  mixins: [common, codeTools],
  data() {
    return {
      visible: false,
      pageLoading: false,
      mobile: '',
      tabId: '',
      formData: {}
    };
  },
  computed: {},
  methods: {
    open(formData, tabId) {
      this.formData = JSON.parse(JSON.stringify(formData));
      this.tabId = tabId;
      let url = '';
      if (tabId == 1) {
        // 结算单发放
        url = '/buz/userCashWithdrawLog/okbRiskBatchPreCheck';
      } else if (tabId == 2) {
        // 风险单发放
        url = '/buz/userCashWithdrawLog/okbRiskPolicyBatchPreCheck';
      } else if (tabId == 3) {
        // 打款失败
        url = '/buz/userCashWithdrawLog/okbRePayPreCheck';
      }
      this.$http({
        url: url,
        type: 'POST',
        data: this.formData
      }).then(res => {
        this.formData.idempotentId = res.data.idempotentId;
        this.mobile = Object.keys(JSON.parse(localStorage.dic).CW_MOBILE)[0];
        this.visible = true;
      });
    },
    ok() {
      if (this.pageLoading) {
        return;
      }
      this.pageLoading = true;
      const formData = JSON.parse(JSON.stringify(this.formData));
      formData.mobile = this.mobile;
      let url = '';
      if (this.tabId == 1) {
        // 结算单发放
        url = '/buz/userCashWithdrawLog/okbRiskBatchHandle';
      } else if (this.tabId == 2) {
        // 风险单发放
        url = '/buz/userCashWithdrawLog/okbRiskPolicyBatchHandle';
      } else if (this.tabId == 3) {
        // 打款失败
        url = '/buz/userCashWithdrawLog/okbReBatchPay';
      }
      this.$http({
        type: 'POST',
        url: url,
        data: formData
      })
        .then(res => {
          this.visible = false;
          this.$notice.success('操作成功');
          this.$emit('reload');
        })
        .finally(e => {
          window.clearInterval(this.timer);
          this.codeIndex = 60;
          window.setTimeout(() => {
            this.pageLoading = false;
          }, 100);
        });
    },
    mask(tel) {
      if (!tel) {
        return '';
      }
      return tel.substr(0, 3) + '****' + tel.substr(7);
    },
    getCodeAjax(mobile) {
      if (!this.$regulars.isPhone(mobile)) {
        this.$notice.msg('请输入正确的手机号');
        return;
      }
      this.timerStart();
      this.$http({
        type: 'GET',
        url: '/buz/userCashWithdrawLog/sendCode',
        data: {
          mobile
        }
      })
        .then(res => {})
        .catch(e => {
          window.clearInterval(this.timer);
          this.codeIndex = 60;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.phone-valid-box {
  /deep/ {
    .ivu-modal-close {
      top: 22px;
    }
    .ivu-modal-body {
      padding-bottom: 0;
      padding-top: 0;
    }
    .ivu-modal-header {
      height: auto;
      line-height: 1.5;
      justify-content: center;
      text-align: center;
      padding: 10px 0;
    }
  }
}

.phone-valid-title {
  font-size: 24px;
  color: #17233d;
}

.phone-valid-tip {
  font-size: 14px;
  color: #515a6e;
  margin-top: 5px;
}

.phone-code-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: left;

  .phone-number {
    width: 400px;
    line-height: 40px;
    font-size: 16px;
    color: #515a6e;
    padding: 10px 0;
  }
}

.phone-code-box {
  width: 400px;
  height: 50px;
  display: flex;
  align-items: center;
  border: 1px solid rgb(220, 223, 230);
  border-radius: 4px;
  margin-bottom: 20px;

  img {
    margin: 0 8px;
  }

  input {
    width: 230px;
    height: 48px;
    font-size: 14px;
  }

  span {
    width: 110px;
    text-align: center;
    margin: 0 11px;
    font-size: 14px;
    color: #727c8e;
    cursor: pointer;
  }

  .active {
    color: #236dff;
  }
}

/deep/.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 0;
  }
}
</style>
